import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("BoardStore");
export const useBoardStoreActions = useActions;
export const useBoardStoreGetters = useGetters;
export const useBoardStoreMutations = useMutations;
export const useBoardStoreState = useState;